import {BrowserRouter as Router} from "react-router-dom"

import AppRoutes from "./router/AppRoutes";
import {AuthProvider} from "./contex/AuthContext.jsx";

function App() {

    return (
        <Router>
            <AuthProvider>
                <AppRoutes/>
            </AuthProvider>
        </Router>
    )

}

export default App;
